import { Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OrderDetailsCard } from "./OrderDetailsCard";

/**
 * Container for the list of the courier's own deliveries.
 * Composes OrderDetailsCard for each item.
 */
export const MyDeliveriesList = ({
  title = "Mes livraisons",
  testId = "my-orders-list",
  myOrders,
  onRefresh,
  ratedOrders,
  ratingOrderId,
  ratingScore,
  onAdvance,
  onStartRating,
  onSetScore,
  onSubmitRating,
  onCancelRating,
}) => {
  return (
    <Card className={`shadow-lg scroll-mt-24 ${testId === "active-course-list" ? "border-2 border-[#D4AF37]" : ""}`} data-testid={testId}>
      <CardHeader>
        <div className="flex justify-between items-center gap-3">
          <CardTitle className="flex flex-wrap items-center gap-2 min-w-0">
            <Navigation className="w-5 h-5" />
            {title}{" "}
            {myOrders.length > 0 && (
              <span className="ml-1 px-2 py-0.5 rounded-full bg-[#D4AF37] text-[#0F172A] text-[10px] font-black">
                {myOrders.length}
              </span>
            )}
          </CardTitle>
          <Button onClick={onRefresh} variant="outline" className="rounded-full" size="sm">
            🔄 Actualiser
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {myOrders.length === 0 ? (
          <p className="text-center text-slate-300 font-bold py-8">Aucune livraison</p>
        ) : (
          <div className="space-y-4">
            {myOrders.map((order) => (
              <OrderDetailsCard
                key={order.id}
                order={order}
                rated={!!ratedOrders[order.id]}
                ratingOrderId={ratingOrderId}
                ratingScore={ratingScore}
                onAdvance={onAdvance}
                onStartRating={onStartRating}
                onSetScore={onSetScore}
                onSubmitRating={onSubmitRating}
                onCancelRating={onCancelRating}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
